var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2861_5625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 3.57143V1",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.07227 3.57143V1",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.64258 3.57143V1",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7857 2.28564H1.35714C1.12981 2.28564 0.911797 2.37595 0.751051 2.5367C0.590306 2.69744 0.5 2.91546 0.5 3.14279V11.2856C0.5 11.513 0.590306 11.731 0.751051 11.8917C0.911797 12.0525 1.12981 12.1428 1.35714 12.1428H10.7857C11.013 12.1428 11.2311 12.0525 11.3918 11.8917C11.5526 11.731 11.6429 11.513 11.6429 11.2856V3.14279C11.6429 2.91546 11.5526 2.69744 11.3918 2.5367C11.2311 2.37595 11.013 2.28564 10.7857 2.28564Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2861_5625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.04688 5.1665V7.89613",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.04664 10.2056C6.00837 10.2056 5.97167 10.1835 5.94461 10.1441C5.91755 10.1047 5.90234 10.0513 5.90234 9.99562C5.90234 9.93993 5.91755 9.88652 5.94461 9.84714C5.97167 9.80777 6.00837 9.78564 6.04664 9.78564",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.04688 10.2056C6.08515 10.2056 6.12185 10.1835 6.14891 10.1441C6.17597 10.1047 6.19117 10.0513 6.19117 9.99562C6.19117 9.93993 6.17597 9.88652 6.14891 9.84714C6.12185 9.80777 6.08515 9.78564 6.04688 9.78564",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2861_5625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2861_5625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6.66667,
    fill: "white",
    transform: "translate(2.66602 4.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarAlertIcon);
export default __webpack_public_path__ + "static/media/calendar-alert-icon.c87901aa33c6ee6e12d6ae1a2cb83a08.svg";
export { ForwardRef as ReactComponent };